import request from '@/utils/request'

let InvoiceApi = {

  /*发票列表*/
  list(data) {
    return request._post('/shop/plus.invoice.Index/index', data);
},
/*添加发票*/
add(data) {
    return request._post('/shop/plus.invoice.Index/add', data);
},
/*修改发票*/
edit(data) {
    return request._post('/shop/plus.invoice.Index/edit', data);
},
/*删除发票*/
del(data) {
    return request._post('/shop/plus.invoice.Index/del', data);
},
/*发票详情*/
detail(data) {
  return request._post('/shop/plus.invoice.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.invoice.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.invoice.Setting/getSetting', data, errorback);
    },
}
export default InvoiceApi;



// WEBPACK FOOTER //
// ./src/api/invoice.js